import React, { useState } from "react";
import DashboardLayout from "../components/DashboardLayout";

export default function ReviewsPage() {
    // Mock data - will be replaced with API calls
    const [reviews] = useState([
        {
            id: 1,
            clientName: "Rahul Sharma",
            rating: 5,
            date: "2024-02-15",
            comment: "Excellent trainer! Lost 15kg in 3 months. Very professional and motivating. Highly recommended!",
            program: "Weight Loss",
            verified: true,
        },
        {
            id: 2,
            clientName: "Priya Patel",
            rating: 5,
            date: "2024-02-10",
            comment: "Best decision I made! The personalized workout plan and diet guidance helped me achieve my fitness goals. Thank you!",
            program: "Muscle Building",
            verified: true,
        },
        {
            id: 3,
            clientName: "Amit Kumar",
            rating: 4,
            date: "2024-01-28",
            comment: "Great experience overall. Very knowledgeable and supportive. Would recommend to anyone looking to get fit.",
            program: "Yoga",
            verified: true,
        },
        {
            id: 4,
            clientName: "Sneha Reddy",
            rating: 5,
            date: "2024-01-15",
            comment: "Amazing transformation journey! The trainer understood my needs and created a perfect plan. Results speak for themselves!",
            program: "1:1 Personal Training",
            verified: true,
        },
        {
            id: 5,
            clientName: "Vikram Singh",
            rating: 4,
            date: "2023-12-20",
            comment: "Very professional and dedicated. Helped me build strength and confidence. Great value for money!",
            program: "Strength Training",
            verified: false,
        },
    ]);

    const averageRating = (reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length).toFixed(1);

    const ratingDistribution = {
        5: reviews.filter((r) => r.rating === 5).length,
        4: reviews.filter((r) => r.rating === 4).length,
        3: reviews.filter((r) => r.rating === 3).length,
        2: reviews.filter((r) => r.rating === 2).length,
        1: reviews.filter((r) => r.rating === 1).length,
    };

    const renderStars = (rating) => {
        return [...Array(5)].map((_, index) => (
            <i
                key={index}
                className={`bi ${index < rating ? "bi-star-fill" : "bi-star"}`}
                style={{ color: index < rating ? "#ffc107" : "#dee2e6" }}
            ></i>
        ));
    };

    const getRatingPercentage = (count) => {
        return reviews.length > 0 ? (count / reviews.length) * 100 : 0;
    };

    return (
        <DashboardLayout activeTab="reviews">
            <div className="reviews-tab">
            <div className="tab-header">
                <div>
                    <h3>
                        <i className="bi bi-star-fill me-2"></i>
                        Reviews & Ratings
                    </h3>
                    <p className="text-muted">See what your clients are saying about you</p>
                </div>
            </div>

            {/* Rating Summary */}
            <div className="rating-summary-section">
                <div className="row g-4">
                    <div className="col-md-4">
                        <div className="overall-rating-card">
                            <div className="rating-number">{averageRating}</div>
                            <div className="rating-stars">{renderStars(Math.round(averageRating))}</div>
                            <p className="rating-text">Based on {reviews.length} reviews</p>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="rating-breakdown">
                            <h6 className="mb-3">Rating Distribution</h6>
                            {[5, 4, 3, 2, 1].map((star) => (
                                <div key={star} className="rating-bar-item">
                                    <div className="rating-label">
                                        {star} <i className="bi bi-star-fill"></i>
                                    </div>
                                    <div className="rating-bar-container">
                                        <div
                                            className="rating-bar-fill"
                                            style={{ width: `${getRatingPercentage(ratingDistribution[star])}%` }}
                                        ></div>
                                    </div>
                                    <div className="rating-count">{ratingDistribution[star]}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Reviews List */}
            <div className="reviews-section">
                <h5 className="section-title mb-4">
                    <i className="bi bi-chat-quote me-2"></i>
                    Client Reviews ({reviews.length})
                </h5>

                {reviews.length > 0 ? (
                    <div className="reviews-list">
                        {reviews.map((review) => (
                            <div key={review.id} className="review-card">
                                <div className="review-header">
                                    <div className="reviewer-info">
                                        <div className="reviewer-avatar">
                                            {review.clientName.charAt(0).toUpperCase()}
                                        </div>
                                        <div>
                                            <h6 className="reviewer-name">
                                                {review.clientName}
                                                {review.verified && (
                                                    <i
                                                        className="bi bi-patch-check-fill text-primary ms-2"
                                                        title="Verified Client"
                                                    ></i>
                                                )}
                                            </h6>
                                            <div className="review-meta">
                                                <span className="review-date">
                                                    {new Date(review.date).toLocaleDateString("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                    })}
                                                </span>
                                                <span className="review-program">• {review.program}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="review-rating">{renderStars(review.rating)}</div>
                                </div>
                                <div className="review-body">
                                    <p>{review.comment}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <i className="bi bi-star" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                        <p className="text-muted mt-2">No reviews yet</p>
                        <p className="text-muted">Reviews from your clients will appear here</p>
                    </div>
                )}
            </div>

            {/* Testimonials Section */}
            <div className="testimonials-section mt-5">
                <h5 className="section-title mb-4">
                    <i className="bi bi-quote me-2"></i>
                    Featured Testimonials
                </h5>
                <div className="row g-3">
                    {reviews
                        .filter((r) => r.rating === 5)
                        .slice(0, 3)
                        .map((review) => (
                            <div key={review.id} className="col-md-4">
                                <div className="testimonial-card">
                                    <div className="testimonial-quote">
                                        <i className="bi bi-quote"></i>
                                    </div>
                                    <p className="testimonial-text">{review.comment}</p>
                                    <div className="testimonial-author">
                                        <strong>{review.clientName}</strong>
                                        <span className="d-block text-muted">{review.program}</span>
                                    </div>
                                    <div className="testimonial-rating">{renderStars(review.rating)}</div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            {/* Stats */}
            <div className="review-stats mt-5">
                <div className="row g-3">
                    <div className="col-md-3">
                        <div className="stat-box">
                            <div className="stat-icon" style={{ background: "linear-gradient(135deg, #ffd89b 0%, #19547b 100%)" }}>
                                <i className="bi bi-star-fill"></i>
                            </div>
                            <div className="stat-content">
                                <h4>{averageRating}</h4>
                                <p>Average Rating</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="stat-box">
                            <div className="stat-icon" style={{ background: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)" }}>
                                <i className="bi bi-chat-quote-fill"></i>
                            </div>
                            <div className="stat-content">
                                <h4>{reviews.length}</h4>
                                <p>Total Reviews</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="stat-box">
                            <div className="stat-icon" style={{ background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" }}>
                                <i className="bi bi-hand-thumbs-up-fill"></i>
                            </div>
                            <div className="stat-content">
                                <h4>{ratingDistribution[5]}</h4>
                                <p>5-Star Reviews</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="stat-box">
                            <div className="stat-icon" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}>
                                <i className="bi bi-patch-check-fill"></i>
                            </div>
                            <div className="stat-content">
                                <h4>{reviews.filter((r) => r.verified).length}</h4>
                                <p>Verified Reviews</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </DashboardLayout>
    );
}
